// @flow
import * as React from 'react';
import Screen from '../../Components/Screen';

import Breadcrumbs from './Components/Breadcrumbs';
import Header from './Components/Header';
import Filters from './Components/Filters';
import Table from './Components/Table';
import Footer from './Components/Footer';
import ProjectModal from '../../Modals/Project';

type Props = {
  projects: [],
  projectTotals: [],
  projectPhases: [],
  projectStatuses: [],
  clients: [],
  clientContacts: [],
  users: [],
  subcontractors: [],
  pagination: {},
  filters: any,
  fetching: boolean,
  showProjectModal: boolean,
  searchTerm: string,
  serviceTypes: [],
  componentDidMount: () => void,
  onChangeSearch: () => void,
  onChangeTable: () => void,
  onClickNewProject: () => void,
  onCloseProjectModal: () => void,
  didCreateProject: () => void,
  onChangeProjectField: () => void,
  onChangeFilter: () => void,
  onSubmitSearch: () => void,
  onClickExport: () => void
}

export default class extends React.PureComponent<Props> {

  componentDidMount = () => this.props.componentDidMount();


  render() {

    const {
      projects,
      projectTotals,
      projectPhases,
      projectStatuses,
      clients,
      clientContacts,
      users,
      subcontractors,
      pagination,
      filters,
      fetching,
      showProjectModal,
      searchTerm, 
      serviceTypes,
      onChangeSearch,
      onChangeTable,
      onClickNewProject,
      onCloseProjectModal,
      didCreateProject,
      onChangeProjectField,
      onChangeFilter,
      onSubmitSearch,
      onClickExport

    } = this.props;

    return (

      <Screen>

        <Breadcrumbs />

        <Header
          searchTerm={searchTerm}
          onClickExport={onClickExport}
          onSubmitSearch={onSubmitSearch}
          onChangeSearch={onChangeSearch}
          onClickNewProject={onClickNewProject}
        />

        <Filters
          filters={filters}
          projectPhases={projectPhases}
          projectStatuses={projectStatuses}
          clients={clients}
          users={users}
          subcontractors={subcontractors}
          onChangeFilter={onChangeFilter}
        />

        <Table
          projects={projects}
          projectPhases={projectPhases}
          clientContacts={clientContacts}
          fetching={fetching}
          pagination={pagination}
          onChangeTable={onChangeTable}
          onChangeProjectField={onChangeProjectField}
          serviceTypes={serviceTypes}
        />

        <Footer
          projectTotals={projectTotals}
        />

        {showProjectModal && (
          
          <ProjectModal
            onClose={onCloseProjectModal}
            didCreate={didCreateProject}
          />
          
        )}

      </Screen>

    )
  };
}